import React from 'react';
import { useTranslation } from 'react-i18next';
import { MINDSET_CARD_ID } from 'utils/mindset';
import Box from 'components/Box';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import Landmark from 'components/Landmark';
import Spinner from 'components/Spinner';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MindsetAgentCard(_ref) {
  var mindsetLoadingStatus = _ref.mindsetLoadingStatus,
    onLoad = _ref.onLoad;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Card, {
    position: "relative",
    height: "70vh",
    pb: "m",
    children: [mindsetLoadingStatus === 'loading' && /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Spinner, {})
    }), mindsetLoadingStatus === 'error' && /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Landmark, {
        icon: "logout",
        children: t('error_could_not_load_data')
      })
    }), /*#__PURE__*/_jsx(Box, {
      height: "100%",
      id: MINDSET_CARD_ID,
      onLoadCapture: onLoad
    })]
  });
}
export default MindsetAgentCard;